import { COLORS, TYPO } from '@/b2b/shared/consts';
import { LogoBlack } from '@/b2b/shared/icons';
import { BreakpointsEnum } from '@/b2b/shared/types';
import { UiButton } from '@/b2b/shared/ui';
import styled from 'styled-components';

interface Props {
  isB2B?: boolean;
}

export const LoginBlock = ({ isB2B }: Props) => {
  return (
    <div>
      <Logo />
      {!isB2B && (
        <>
          <ButtonLink
            href={`/?service=FOR_YOURSELF#services`}
            target="_self"
          >
            <Button styleType="primary">Подобрать психолога</Button>
          </ButtonLink>
          <ButtonLink
            href={'/login'}
            target="_self"
          >
            <Button styleType="primary">Войти в личный кабинет</Button>
          </ButtonLink>
        </>
      )}
    </div>
  );
};

const Logo = styled(LogoBlack)`
  width: 148px;
  height: 38px;
  margin-bottom: 40px;

  @media (min-width: ${BreakpointsEnum.lgm}px) {
    margin-bottom: 30px;
  }
`;

const ButtonLink = styled.a`
  display: block;
  width: 100%;
  margin-top: 20px;
  
  @media (min-width: ${BreakpointsEnum.lgm}px) {
    width: 221px;
  }
`;

const Button = styled(UiButton)`
  ${TYPO.body2}
  width: 100%;
  height: 48px;
  border-radius: 26px;
  background-color: ${COLORS.secondary300};
  color: ${COLORS.black};
  text-wrap: nowrap;

  &:hover {
    background-color: ${COLORS.secondary400} !important;
    color: ${COLORS.black} !important;
  }

  @media (min-width: ${BreakpointsEnum.lgm}px) {
    width: 221px;
  }
`;
